import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { dashboardActions } from '../../../../store/slices/dashboardSlice/dashboardSlice';

export const useModalReconciliationOfCalculations = () => {
    const dispatch = useDispatch();
    const { modalMode, customerModalLoader, can_export_financial_info } = useSelector(
        //@ts-ignore
        (state) => state.dashboardReducer
    );
    const onCloseModal = useCallback(() => {
        dispatch(dashboardActions.onModalMode(null));
    }, []);

    const onExportAct = useCallback(() => {
        //@ts-ignore
        window.location.href = routable.getRoute('exportAct');
    }, []);
    return {
        modalMode,
        onCloseModal,
        customerModalLoader,
        onExportAct,
        can_export_financial_info,
    };
};
